import Parallax from 'parallax-js'
// Определяем селектор для паралакса
let scene = document.querySelector('.what_technologies_do_we_use__scene');
let parallaxInstance = new Parallax(scene, {
    hoverOnly: true,
    frictionY: 0
});